import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 8px;


  /* controla a cor do ícone via prop */
  svg {
    color: ${({ iconColor }) => iconColor || 'currentColor'};
  }

  svg path {
    fill: currentColor;
  }

  @media (max-width: 460px) {
    display: none; /* Esconde em dispositivos moveis */
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;

export const TooltipText = styled.span`
  visibility: hidden;
  min-width: 280px;
  max-width: 300px;
  opacity: 0;
  transition: opacity 0.2s ease;
  position: absolute;
  top: 120%;
  left: 50%;
  color: ${(props) => props.theme.colors.newTooltipTextColor};
  background: ${(props) => props.theme.colors.newTooltipBackgroundColor};
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 999;
  pointer-events: none;
  font-weight: 400;
`;